// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"7538":"recorder","9983":"profiler"}[chunkId] + "." + {"7538":"f0c9cc42b10f075a","9983":"28db9f4c871d5223"}[chunkId] + ".js";
};